// removed by extract-text-webpack-plugin
module.exports = {"HardwareButton":"purify_HardwareButton__HardwareButton___1_R5W","left":"purify_HardwareButton__left___1gyG8","center":"purify_HardwareButton__center___1nopV","right":"purify_HardwareButton__right___Pxcpp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/HardwareButton/HardwareButton.scss
// module id = 188
// module chunks = 0